import React,{useState} from "react";
import {json, useNavigate, useSearchParams} from "react-router-dom";
import { useEffect } from "react";
import { InventarioInicio } from "./inventarioinicio";
import { VehiculoInicio } from "./vehiculoinicio";

export function Inicio(){
    const navigate = useNavigate();
    const[params] = useSearchParams();

    //parametros
    const [codigo,setCodigo] = useState(params.get('codigo') ?? '');
    const idactivo = params.get('idactivo')?? '';
    const [tipo,setTipo] = useState(params.get('tipo')??'');    
    
    const[clave,setClave]=useState("");
    const[mensaje,setMensaje] = useState("");
    const [activo,setActivo]=useState(null);
    const [tipovehiculo,setTipoVehiculo]=useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const onClaveChange = e => setClave(e.target.value);
    
    const [cargando,setCargando] = useState(1);
    useEffect(()=>{
        const requestOptions = {
            method: "GET",
            headers: {"Content-Type": "application/json"}
        };
            fetch(process.env.REACT_APP_INVENTARIO_API_URL+"api/etiqueta/show/"+idactivo,requestOptions)
            .then(response => response.json())
            .then(res =>{
                setActivo(res);
                if(res.rest==1){
                    setCodigo(res.activo.codigo);
                    setTipo(res.activo.tipo);
                    console.log(res);
                    if(res.activo.tipo=='flota'){
                        if(res.activo.vehiculo!=null){
                            setTipoVehiculo(res.activo.vehiculo.idcarroceria);
                        }else{
                            setTipoVehiculo(23); //por defecto coo remolque
                        }
                    }
                    setCargando(2);
                }else{
                    setCargando(3);
                }
            
            })
            .catch(error => {
                console.error("Error:", error);
                setCargando(3);
                setMensaje("Error de conexión. Intente nuevamente.");
            });
    },[]);

    const handleInventarioFlota = e =>{
        e.preventDefault();
        setIsLoading(true);
        setMensaje("");

        const data = { codigo,clave };
        const requestOptions = {
            method: "POST",
            headers: {"Content-Type": "application/json"},
            body: JSON.stringify(data)
        };
        fetch(process.env.REACT_APP_INVENTARIO_API_URL+"api/personal/validar",requestOptions)
        .then(response => response.json())
        .then(res =>{
            console.log(res);
            setIsLoading(false);
            if(res.respuesta==1){
                setMensaje("");
                navigate('/activo/inventario/?idactivo='+idactivo+'&tipo='+tipo+'&codigo='+codigo+'&idpersonal='+res.personal.idpersonal+'&tipovehiculo='+tipovehiculo);
            }else
            {
                setMensaje("Error de acceso, ingrese una clave correcta.");
            }
        })
        .catch(error => {
            console.error("Error:", error);
            setIsLoading(false);
            setMensaje("Error de conexión. Intente nuevamente.");
        });
    };

    const handleVerActivo = e =>{
        e.preventDefault();
        setIsLoading(true);
        setMensaje("");
        
        const data = { codigo,clave };
        const requestOptions = {
            method: "POST",
            headers: {"Content-Type": "application/json"},
            body: JSON.stringify(data)
        };
        fetch(process.env.REACT_APP_INVENTARIO_API_URL+ "api/personal/validar",requestOptions)
        .then(response => response.json())
        .then(res => {
            console.log(res);
            setIsLoading(false);
            if(res.respuesta==1){
                console.log("acceso correcto ver activo");
                setMensaje("");
                navigate('/activo/ver/?idactivo='+idactivo+'&tipo='+tipo+'&codigo='+codigo);
            }else
            {
                console.log("acceso incorrecto vuelve a intentar");
                setMensaje("Error de acceso, ingrese una clave correcta.");
            }
        })
        .catch(error => {
            console.error("Error:", error);
            setIsLoading(false);
            setMensaje("Error de conexión. Intente nuevamente.");
        });
    };

    const handleRegistrarActivo = e =>{
        e.preventDefault();
        setIsLoading(true);
        setMensaje("");
        
        const data = { codigo,clave };
        const requestOptions = {
            method: "POST",
            headers: {"Content-Type": "application/json"},
            body: JSON.stringify(data)
        };
        fetch(process.env.REACT_APP_INVENTARIO_API_URL+ "api/personal/validar",requestOptions)
        .then(response => response.json())
        .then(res => {
            console.log(res);
            setIsLoading(false);
            if(res.respuesta==1){
                console.log("acceso correcto registrar activo");
                setMensaje("");
                navigate('/activo/registro/?idactivo='+idactivo+'&tipo='+tipo+'&codigo='+codigo+'&accion='+cargando+'&tipo=flota');
            }else
            {
                console.log("acceso incorrecto vuelve a intentar");
                setMensaje("Error de acceso, ingrese una clave correcta.");
            }
        })
        .catch(error => {
            console.error("Error:", error);
            setIsLoading(false);
            setMensaje("Error de conexión. Intente nuevamente.");
        });
    };

    return (
        <div className="container Inicio">
            <div className="row justify-content-center">
                <div className="col-md-8 col-lg-6">
                    <div className="card shadow-sm">
                        <div className="card-header bg-danger text-white">
                            <h3 className="mb-0 text-center">Sistema de Inventario</h3>
                        </div>
                        <div className="card-body p-4">
                            {cargando === 1 && (
                                <div className="text-center p-4">
                                    <div className="spinner-border text-primary" role="status">
                                        <span className="visually-hidden">Cargando...</span>
                                    </div>
                                    <p className="mt-2">Cargando información del activo...</p>
                                </div>
                            )}
                            
                            {cargando === 2 && activo && activo.rest === 1 && (
                                <div>
                                    <div className="alert alert-info">
                                        <div className="d-flex align-items-center">
                                            <i className="bi bi-info-circle-fill me-2 fs-4"></i>
                                            {tipo === 'general' &&(
                                                <div>
                                                <h5 className="mb-1">Etiqueta para registrar</h5>
                                                <p className="mb-0">ID: <strong>{idactivo}</strong></p>
                                            </div>

                                            )}
                                            {tipo === 'flota' &&(
<div>
                                                <h5 className="mb-1">Información del Activo</h5>
                                                <p className="mb-0">ID: <strong>{idactivo}</strong> | Código: <strong>{codigo}</strong></p>
                                            </div>
                                            )}
                                            
                                        </div>
                                    </div>
                                    
                                    {mensaje && (
                                        <div className="alert alert-danger">
                                            <i className="bi bi-exclamation-triangle-fill me-2"></i>
                                            {mensaje}
                                        </div>
                                    )}
                                    
                                    
                                </div>
                            )}
                            
                            {cargando === 3 && (
                                <div className="alert alert-warning">
                                    <i className="bi bi-exclamation-triangle-fill me-2 fs-4"></i>
                                    <h5>Etiqueta no registrada</h5>
                                    <p>La etiqueta con ID {idactivo} no esta registrado en el sistema, comuniquese con TIC.</p>
                                </div>
                            )}


                                    <form className="needs-validation" noValidate>
                                        <div className="mb-3">
                                            
                                            {cargando !== 3 &&(
                                                <>
                                                <label htmlFor="clave" className="form-label">Ingrese su clave de acceso:</label>
                                                <div className="input-group">
                                                <span className="input-group-text"><i className="bi bi-key-fill"></i></span>
                                                <input 
                                                    type="password" 
                                                    className="form-control" 
                                                    id="clave" 
                                                    value={clave} 
                                                    onChange={onClaveChange} 
                                                    required 
                                                />
                                                </div>
                                                </>
                                            )}
                                            
                                        </div>
                                        
                                        <div className="d-grid gap-2">
                                            {tipo === 'flota' && cargando === 2 && (
                                                <>
                                                <button 
                                                    className="btn btn-primary" 
                                                    onClick={handleInventarioFlota}
                                                    disabled={isLoading}
                                                >
                                                    {isLoading ? (
                                                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                    ) : (
                                                        <i className="bi bi-clipboard-check me-2"></i>
                                                    )}
                                                    Realizar Inventario
                                                </button>

                                                {/*<button 
                                                    className="btn btn-outline-primary" 
                                                    onClick={handleVerActivo}
                                                    disabled={isLoading}
                                                >
                                                {isLoading ? (
                                                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                ) : (
                                                    <i className="bi bi-eye me-2"></i>
                                                )}
                                                Ver Activo
                                                </button> */}
                                                </>
                                            )}
                                            
                                            
                                            {(cargando === 2 && tipo === 'general') && (
                                                <button 
                                                    className="btn btn-outline-secondary" 
                                                    onClick={handleRegistrarActivo}
                                                    disabled={isLoading}
                                                    >
                                                                                            {isLoading ? (
                                                                                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                                                            ) : (
                                                                                                <i className="bi bi-pencil-square me-2"></i>
                                                                                            )}
                                                                                            Registrar Activo
                                                </button>

                                            )}
                                            
                                            
                                            
                                        </div>
                                    </form>




                            



                        </div>
                    </div>
                    
                    {activo && activo.rest === 1 && (
                        <div className="mt-4">
                            <InventarioInicio idactivo={idactivo} />
                            {/*tipo === 'flota' && <VehiculoInicio idactivo={idactivo} />*/}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}